import { render, staticRenderFns } from "./Grid1TodayUpdates.vue?vue&type=template&id=33572f72&scoped=true"
import script from "./Grid1TodayUpdates.vue?vue&type=script&lang=js"
export * from "./Grid1TodayUpdates.vue?vue&type=script&lang=js"
import style0 from "./Grid1TodayUpdates.vue?vue&type=style&index=0&id=33572f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33572f72",
  null
  
)

export default component.exports